<template>
    <ViewCover style="height: 100%; overflow: hidden;">
        <ScrollHandler>
            <iframe key="iframe_doc" 
                frameborder="0"
                width="100%" height="98%" 
                ref="scroller"
                class="documentation" 
                src="https://wiki.carbis.ru/external/%D0%B4%D0%BE%D1%81%D1%82%D0%B0%D0%B2%D0%BA%D0%B0"
            >
            </iframe>
        </ScrollHandler>
    </ViewCover>
</template>

<script>
import ViewCover from './ViewCover.vue';
import ScrollHandler from '@/components/scroller_handler'

export default{
    methods:{

    },
    components:{
        ViewCover,
        ScrollHandler
    }
}
</script>

<style>
.documentation{
    overflow: hidden;
}

::-webkit-scrollbar {
    display: none !important;
}
</style>